import React from 'react';
import classnames from 'classnames';
import './SectionContainer.scss';

function SectionContainer({
  datatestid,
  children,
  className,
  fullWidth,
  type,
  background,
  border,
  margin,
  padding,
  ...props
}) {
  const backgroundClass = background || 'bgWhite';
  return (
    <div
      className={classnames(
        'SectionContainer',
        {
          fullWidth,
        },
        type,
        backgroundClass,
        border,
        margin,
        padding,
        className,
      )}
      data-testid={datatestid ? `${datatestid}-section` : null}
      {...props}
    >
      {children}
    </div>
  );
}

SectionContainer.defaultProps = {
  margin: 'margB32 m-margB16 m-margLR0',
  padding: 'padT40 padB48 m-padT24',
};

export { SectionContainer };
